import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { SECURITY_MODULE_CONFIG, SecurityModuleConfig } from '../security-config';
import { AuthenticationBackendService } from '../services/authentication-backend.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(public authService: AuthenticationBackendService, 
    public router: Router,
  @Inject(SECURITY_MODULE_CONFIG) private config: SecurityModuleConfig) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated().pipe(map(isAuth => {
      if (!isAuth) {
        // window.alert('Access Denied, Login is Required to Access This Page!');
        this.router.navigate([this.config.loginUrl]);
      }
      return isAuth;
    }));
  }
}